import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { X } from 'lucide-react';
import BottomSheet from 'components/_UI/BottomSheet';
import useMediaQuery from 'hooks/useMediaQuery';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';

export default function MenuFormModal({ isOpen, onClose, title, size = 'default', children }) {
    const isDesktop = useMediaQuery(`(min-width: ${breakpoints.lg})`);

    useEffect(() => {
        if (isDesktop && isOpen) {
            document.body.style.overflow = 'hidden';
            return () => { document.body.style.overflow = ''; };
        }
    }, [isDesktop, isOpen]);

    if (!isDesktop) {
        return (
            <BottomSheet isOpen={isOpen} onClose={onClose} title={title} size={size}>
                {children}
            </BottomSheet>
        );
    }

    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <Overlay onClick={onClose}>
            <Card onClick={e => e.stopPropagation()} $wide={size === 'large'}>
                <Header>
                    <Title>{title}</Title>
                    <CloseBtn onClick={onClose} aria-label='Fechar'>
                        <X size={20} color={colors.night} />
                    </CloseBtn>
                </Header>
                <Body>{children}</Body>
            </Card>
        </Overlay>,
        document.body
    );
}

const Overlay = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(26, 26, 26, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 200;
    padding: 24px;
    overflow-y: auto;
`;

const Card = styled.div`
    background: #fff;
    border-radius: 16px;
    width: 100%;
    max-width: ${({ $wide }) => $wide ? '640px' : '480px'};
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
    margin: auto;
`;

const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 20px 24px;
    border-bottom: 1px solid ${colors.neutralDark};
    flex-shrink: 0;
`;

const Title = styled.h3`
    font-size: 17px;
    font-weight: 600;
    color: ${colors.nightDark};
    margin: 0;
`;

const CloseBtn = styled.button`
    width: 32px;
    height: 32px;
    border-radius: 8px;
    border: none;
    background: none;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.15s;
    &:hover { background: ${colors.neutralDark}; }
`;

const Body = styled.div`
    padding: 24px;
    overflow-y: auto;
    flex: 1;
    min-height: 0;
`;
